<div class="doneDiscoverProcess_container" [dir]="pageDir">
    <span class="doneDiscoverProcess_header">{{"discoveryProcess.header" | translate}}</span>
    <span  class="doneDiscoverProcess_text"> {{isMale ? (messageKeyPrefix + ".MALE" | translate):(messageKeyPrefix + ".FEMALE" | translate)}}</span>
    <mat-dialog-actions align="end">
        <button class="doneDiscoverProcess_button" mat-raised-button mat-dialog-close >{{"discoveryProcess.buttonText" | translate}}</button>
    </mat-dialog-actions>
</div>